<template>
  <div class="column is-9">
    <div class="loading" v-if="loading">
        <pulse-loader :loading="loading"></pulse-loader>
    </div>
    <div v-if="page && !loading" class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>{{ page | hide }}</h1>
      </div>
      <div class="column">
        <component :key="index" v-for="(content,index) in page.contents" :is="content.isTip ? 'div' : 'p'">
          <div v-if="content.isTip" class="columns guide-focus-bloc is-info is-flex-mobile">
            <div class="column is-2-mobile is-2-tablet is-2-desktop is-1-widescreen is-1-fullhd has-text-centered">
              <i class="fal fa-hand-peace fa-2x"></i>
            </div>
            <div class="column" v-html="content.html">
            </div>
          </div>
          <div v-else v-html="content.html"></div>
        </component>
      </div>
      <div class="column is-border-top">
        <p>Cet article ne vous a pas aidé ? <a href="#">Contactez-nous par mail</a> ou <a href="#">utilisez notre livechat</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import { mapState } from 'vuex'
import PageTile from '../components/PageTile.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { objectPage } from '../utils.js'
const converter = new showdown.Converter()
// const contentful = require('contentful')

export default {
  name: 'Page',
  components: {
    PageTile,
    PulseLoader
  },
  data () {
    return {
      page: null,
      loading: false
    }
  },
  computed: {
    ...mapState(['rubrics', 'contentfullClient', 'profil'])
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    checkprofilpage (page) {
      if (page.destinations !== undefined) {
        if (page.destinations.includes(this.profil) === false) {
          console.log(this.profil)
          console.log(page.destinations)
          this.$router.replace('/error')
        }
      }
    },
    fetchData () {
      this.pages = []
      this.rubric = null
      this.loading = true
      this.contentfullClient.getEntries({
        content_type: 'faqPage',
        'fields.redirectId': this.$route.params.pageId,
        include: 2
      }).then(response => {
        let items = response.items
        console.log(items)
        let item = response.items[0]
        this.loading = false
        this.page = objectPage(item)
        this.checkprofilpage(this.page)
        if (item.fields['content'] !== undefined) {
          this.page.contents.push({
            html: converter.makeHtml(item.fields['content']),
            isTip: false
          })
        }
        if (item.fields['tips'] !== undefined) {
          this.page.contents.push({
            html: converter.makeHtml(item.fields['tips']),
            isTip: true
          })
        }
        for (let i = 1; i < 6; i++) {
          if (item.fields['content' + i] === undefined) {
            continue
          }
          let content = item.fields['content' + i]
          this.page.contents.push({
            html: converter.makeHtml(content),
            isTip: false
          })
          if (item.fields['tip' + i] === undefined) {
            continue
          }
          let tips = item.fields['tip' + i]
          this.page.contents.push({
            html: converter.makeHtml(tips),
            isTip: true
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
